import { ReactElement } from 'react';

import { Button } from '@mui/material';

import { useBoolean, useSelector } from '../../../../common/hooks';
import Iframe from '../../../../components/Iframe';
import Image from '../../../../components/Image';
import casinoGames from '../../../Games/components/CasinoGames/data';
import Product from '../Product';
import Modal from '../ProductModal';

const fishhunter = casinoGames.find((game) => game.name === 'Fish Hunter');

export default function FishHunter(): ReactElement {
  const user = useSelector((state) => state.user);

  const [modalOpen, setModalOpen] = useBoolean();

  return (
    <>
      <Product
        label='Fish Hunter'
        hash='fishhunter_product'
        color='warning'
        image={
          <Image
            alt='Fish Hunter Image'
            thumbnailSrc='https://cdn.tain.com/demo/products/low-quality/fishhunter.png'
            fullSrc='https://cdn.tain.com/demo/products/high-quality/fishhunter.png'
          />
        }>
        <Button color='warning' onClick={() => setModalOpen.on()} variant='contained'>
          Open
        </Button>
      </Product>

      <Modal
        open={modalOpen}
        title='Fish Hunter'
        video='https://cdn.tain.com/amazing/video/fishhunter.mp4'
        onClose={() => setModalOpen.off()}>
        <Iframe
          title='Fish Hunter Game'
          src={fishhunter ? fishhunter.method(fishhunter.urlData, user.data.sessionId) : ''}
        />
      </Modal>
    </>
  );
}
